import { SaveStateManager } from '../features/save-state'
import { applyResponsiveImage } from '../utils/pathResolver'
import logoRychleSipySvg from '../svg/logo-rychle-sipy.svg?raw'

export class HomeScreen {
  private container: HTMLDivElement
  private onPlayCallback?: () => void
  private onContinueCallback?: () => void
  private onNewGameCallback?: () => void

  constructor(private parentContainer: HTMLElement) {
    // Use existing element from HTML
    this.container = parentContainer.querySelector('.home-screen') as HTMLDivElement
    if (!this.container) {
      throw new Error('Home screen element not found in HTML')
    }
    const logoImage = this.container.querySelector('.home-screen__logo-image') as HTMLElement | null
    if (logoImage) logoImage.innerHTML = logoRychleSipySvg

    this.setupContestInfo()
  }

  private setupContestInfo(): void {
    const contestInfo = this.container.querySelector('.home-screen__contest-info') as HTMLElement | null
    if (!contestInfo) return

    if (window.isContestRemoved) {
      contestInfo.remove()
      return
    }

    const isActive = window.isContestActive !== false

    const bg = document.createElement('img')
    bg.className = 'home-screen__contest-info-bg'
    bg.src = '/assets/images/contest-info-bg.png'
    bg.alt = ''
    applyResponsiveImage(bg)

    if (isActive) {
      const img = document.createElement('img')
      img.className = 'home-screen__contest-info-image'
      img.src = '/assets/images/contest-info.png'
      img.alt = ''
      applyResponsiveImage(img)
      contestInfo.appendChild(bg)
      contestInfo.appendChild(img)
    } else {
      const img = document.createElement('img')
      img.className = 'home-screen__contest-info-image-over'
      img.src = '/assets/images/contest-info-over.png'
      img.alt = ''
      applyResponsiveImage(img)
      const anchor = document.createElement('a')
      anchor.className = contestInfo.className
      anchor.href = '/souteze/rychle-sipy-a-velikonocni-poklad'
      anchor.target = '_blank'
      anchor.appendChild(bg)
      anchor.appendChild(img)
      contestInfo.replaceWith(anchor)
    }
  }

  show(): void {
    this.container.classList.remove('hidden')
    this.updateButtons()
  }

  hide(): void {
    this.container.classList.add('hidden')
  }

  setOnPlay(callback: () => void): void {
    this.onPlayCallback = callback
  }

  setOnContinue(callback: () => void): void {
    this.onContinueCallback = callback
  }

  setOnNewGame(callback: () => void): void {
    this.onNewGameCallback = callback
  }

  updateButtons(): void {
    const buttonsContainer = this.getButtonsContainer()
    if (!buttonsContainer) return

    buttonsContainer.innerHTML = ''
    if (this.hasProgress()) {
      buttonsContainer.appendChild(this.createContinueButton())
      buttonsContainer.appendChild(this.createNewGameButton())
    } else {
      buttonsContainer.appendChild(this.createPlayButton())
    }
  }

  private getButtonsContainer(): Element | null {
    return this.container.querySelector('[data-buttons-container="true"]')
  }

  private createPlayButton(): HTMLButtonElement {
    const button = document.createElement('button')
    button.className = 'button'
    button.textContent = 'Hrát'
    button.addEventListener('click', () => this.onPlayCallback?.())
    return button
  }

  private createContinueButton(): HTMLButtonElement {
    const button = document.createElement('button')
    button.className = 'button'
    button.textContent = 'Pokračovat'
    button.addEventListener('click', () => this.onContinueCallback?.())
    return button
  }

  private createNewGameButton(): HTMLButtonElement {
    const button = document.createElement('button')
    button.className = 'button button--secondary'
    button.textContent = 'Nová hra'
    button.addEventListener('click', () => this.onNewGameCallback?.())
    return button
  }

  private hasProgress(): boolean {
    const state = SaveStateManager.load()
    if (!state) return false
    return state.lastLoadedScene.index >= 0 || Object.keys(state.choices ?? {}).length > 0
  }

  destroy(): void {
    this.hide()
  }
}
